import { Homepage } from "@/components/homepage";
import { SEO } from "@/components/seo";

const Index = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AffinityAim",
    "url": "https://www.affinityaim.com",
    "logo": "https://www.affinityaim.com/logo.png",
    "description": "A small product studio that builds custom web apps, sales prospecting tools, internal business apps, client portals, and workflow automation for B2B companies and sales teams.",
    "foundingDate": "2023",
    "email": "post@affinityaim.com",
    "sameAs": [
      "https://linkedin.com/company/affinityaim"
    ]
  };

  return (
    <>
      <SEO
        title="Affinity Aim | Custom Apps & Internal Tools for B2B Companies"
        description="A small product studio building custom web apps, sales prospecting tools, internal business apps, and workflow automation for B2B companies and sales teams."
        canonical="https://www.affinityaim.com/"
        keywords="custom web apps, sales prospecting tools, workflow automation, B2B software, internal business apps, client portals"
        schema={organizationSchema}
      />
      <Homepage />
    </>
  );
};

export default Index;

